// extracted by mini-css-extract-plugin
module.exports = {"qualificationInput":"StagingAuthorFormCard_qualificationInput_3wwH0","invalidText":"StagingAuthorFormCard_invalidText_3YNN_","spinAround":"StagingAuthorFormCard_spinAround_F4W_h"};